import { navigate, PATHS } from '@client/routes';

type Author = {
  id: string | number;
  badges: string[];
  hasDirectMessagesAccess?: boolean | null;
};

type ReplyInDMParams = {
  author: Author;
  isOwner: boolean;
  isAdminModerator: boolean;
  influencerId: number;
  isInfluencer: boolean;
  isDmFeatureEnabled: boolean;
};

/**
 * Returns a handler function for "Reply in DM" action if the user has permission,
 * otherwise returns undefined.
 *
 * Permission logic:
 * - Creator must have DM feature enabled
 * - User must be owner OR admin/moderator
 * - Target author must NOT be the owner ('own' badge)
 * - Target author must NOT be a creator ('creator' badge)
 * - Target author must have DM access enabled (hasDirectMessagesAccess)
 */
export const getReplyInDMHandler = ({
  author,
  isOwner,
  isAdminModerator,
  influencerId,
  isInfluencer,
  isDmFeatureEnabled,
}: ReplyInDMParams): (() => void) | undefined => {
  const canReplyInDM =
    isDmFeatureEnabled &&
    (isOwner || isAdminModerator) &&
    !author.badges.includes('own') &&
    !author.badges.includes('creator') &&
    author.hasDirectMessagesAccess === true;

  if (!canReplyInDM) return undefined;

  return () =>
    navigate(
      isInfluencer
        ? PATHS.INBOX(Number(author.id))
        : PATHS.INBOX_MESSAGE(influencerId, Number(author.id)),
    );
};
